import React from 'react';

import { ReactComponent as Info } from '../../../assets/svg/icon_info_sign.svg';

import { AppTooltip } from '..';

import './email-tooltip.scss';

const EmailTooltip = ({ styleClass, id,  emailToolTip, place }) => {
  return (
    <div className={`toolTip ${styleClass}`}>
      <span data-tip data-for={id}>
        <Info />
      </span>
      <AppTooltip id={id} place={place}>{emailToolTip} </AppTooltip>
    </div>
  );
};

export default EmailTooltip;
